import React from "react";
import { useLang } from "@/contexts/LanguageContext";

/**
 * TrustedBy — infinite marquee of real client logos.
 * Logos sourced from Wikimedia Commons (Special:FilePath ensures hot-link stability).
 */

const LOGOS = [
  {
    name: "AG2R La Mondiale",
    src: "https://commons.wikimedia.org/wiki/Special:FilePath/AG2R_La_Mondiale_logo.svg",
  },
  {
    name: "Coface",
    src: "https://commons.wikimedia.org/wiki/Special:FilePath/Coface2018.svg",
  },
  {
    name: "Syensqo",
    src: "https://commons.wikimedia.org/wiki/Special:FilePath/Syensqo_Logo_2023.svg",
  },
  {
    name: "Zodiac Milpro",
    src: "https://commons.wikimedia.org/wiki/Special:FilePath/Zodiac+Milpro.png",
  },
  {
    name: "Saur",
    src: "https://fr.wikipedia.org/wiki/Special:FilePath/Logo_Saur_(2022).svg",
  },
];

const Row = ({ ariaHidden = false }) => (
  <div
    className="flex items-center gap-16 sm:gap-24 px-8 sm:px-12 shrink-0"
    aria-hidden={ariaHidden}
  >
    {LOGOS.map((l, i) => (
      <div
        key={i}
        className="flex items-center justify-center h-14 sm:h-16 shrink-0"
        title={l.name}
      >
        <img
          src={l.src}
          alt={l.name}
          loading="lazy"
          className="h-full w-auto max-w-[200px] object-contain grayscale opacity-60 hover:grayscale-0 hover:opacity-100 transition-all duration-500"
          onError={(e) => {
            // graceful text fallback
            e.currentTarget.outerHTML = `<span class="font-heading font-bold tracking-tight text-2xl text-brand-ink/60">${l.name}</span>`;
          }}
        />
      </div>
    ))}
  </div>
);

const TrustedBy = () => {
  const { t } = useLang();
  return (
    <section
      className="bg-white border-y border-brand-border py-16 sm:py-20 overflow-hidden"
      data-testid="trusted-section"
    >
      <div className="container-x">
        <p className="overline text-center" data-testid="trusted-title">
          {t.trusted.title}
        </p>
      </div>

      <div className="mt-12 relative">
        <div className="pointer-events-none absolute inset-y-0 left-0 w-24 sm:w-40 bg-gradient-to-r from-white to-transparent z-10" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-24 sm:w-40 bg-gradient-to-l from-white to-transparent z-10" />

        <div className="marquee flex w-max items-center">
          <Row />
          <Row ariaHidden />
        </div>
      </div>

      <style>{`
        @keyframes marquee {
          from { transform: translateX(0); }
          to { transform: translateX(-50%); }
        }
        .marquee {
          animation: marquee 32s linear infinite;
          will-change: transform;
        }
        .marquee:hover {
          animation-play-state: paused;
        }
      `}</style>
    </section>
  );
};

export default TrustedBy;
